/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取公钥
   */
  getAuthKey: 'GET /auth/key',
  /**
   * 获取图形验证码
   */
  getImageCaptcha: 'GET /auth/image-captcha',
  /**
   * 用户登录
   */
  userLogin: 'POST /auth/validate',
  /**
   * 用户登录
   */
  userLogout: 'POST /auth/logout',
  /**
   * 获取应用
   */
  getApps: 'GET /user/apps',
  /**
   * 获取导航
   */
  getUserGrant: 'GET /user/grant',
  /**
   * 获取用户信息
   */
  getUser: 'GET /user/identity',
  /**
   * 更新密码
   */
  updatePassword: 'POST /user/update-password'
}
